'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LibraryLogo = require('./components/LibraryLogo.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LibraryLogo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-library-logo/lib/index.js
// module id = 546
// module chunks = 1